import request from '../request'

export default {
  getParametros() {
    return request.get('parametro')
  },

  setParametro(key, data) {
    return request.post(`parametro/${key}`, data)
  }
}
